<div class="reassign-input-dialog" [formGroup]="reassignForm"
  [ngClass]="{'reassign-input-dialog__desktop': !isMobile, 'reassign-input-dialog__mobile': isMobile}">

  <!-- Header -->
  <div mat-dialog-title class="reassign-input-dialog__header">
    <div class="reassign-input-dialog__title">Reassign Case</div>
    <div class="reassign-input-dialog__subtitle">Please provide details so CARES can investigate</div>
  </div>

  @if (submitted && reassignForm.invalid) {
    <div class="reassign-input-dialog__validation-banner">
      <mat-icon class="reassign-input-dialog__warning-icon">warning_amber</mat-icon>
      <span>Required fields must be provided before reassignment</span>
    </div>
  }

  <div mat-dialog-content class="reassign-input-dialog__content">

    <!-- Reason for Reassign -->
    <div class="reassign-input-dialog__form-section">
      <div class="reassign-input-dialog__section-title">
        <span class="reassign-input-dialog__required-asterisk">*</span>
        <span>Reason for Reassign</span>
      </div>
      <mat-form-field appearance="outline" class="reassign-input-dialog__full-width">
        <textarea matInput formControlName="reassignReason"
          placeholder="Reason this case does not belong to your restaurant"
          [maxlength]="reassignFieldMaxLength">
        </textarea>

        <mat-hint align="end">
          {{ reassignForm.get('reassignReason')?.value?.length || 0 }} / {{ reassignFieldMaxLength }}
        </mat-hint>


      </mat-form-field>
      @if (reassignForm.get('reassignReason')?.hasError('required') && submitted) {
        <div class="reassign-input-dialog__error-container">
          * Field is required
        </div>
      }
    </div>

    <!-- Customer Contacted? -->
    <div class="reassign-input-dialog__form-section">
      <div class="reassign-input-dialog__section-title">
        <span class="reassign-input-dialog__required-asterisk">*</span>
        <span>Customer Contacted?</span>
      </div>
      <mat-radio-group formControlName="isCustomerContacted" class="reassign-input-dialog__radio-group" fxLayout="row"
        fxLayoutGap="96px">
        <mat-radio-button [value]="true">
          <span class="reassign-input-dialog__radio-label">Yes</span>
        </mat-radio-button>
        <mat-radio-button [value]="false">
          <span class="reassign-input-dialog__radio-label">No</span>
        </mat-radio-button>
      </mat-radio-group>
      @if (reassignForm.get('isCustomerContacted')?.hasError('required') && submitted) {
        <div class="reassign-input-dialog__error-container">
          * Field is required
        </div>
      }
    </div>

    <!-- Suggested Restaurant -->
    <div class="reassign-input-dialog__form-section">
      <div class="reassign-input-dialog__section-title">
        <span>Suggested Restaurant</span>
        <span class="reassign-input-dialog__optional-text">(optional)</span>
      </div>
      <mat-form-field appearance="outline" class="reassign-input-dialog__full-width">
        <textarea matInput formControlName="reassignLocation"
          placeholder="Restaurant name/number that case may belong to"
          [maxlength]="reassignFieldMaxLength">
        </textarea>

        <mat-hint align="end">
          {{ reassignForm.get('reassignLocation')?.value?.length || 0 }} / {{ reassignFieldMaxLength }}
        </mat-hint>

      </mat-form-field>
    </div>

  </div>

  <!-- Footer -->
  <div mat-dialog-actions class="reassign-input-dialog__footer">
    <div class="reassign-input-dialog__buttons">
      <button mat-button (click)="onCancel()" class="reassign-input-dialog__cancel-button">Cancel</button>
      <button mat-button class="reassign-input-dialog__send-button" (click)="onReassignClicked()">
        Reassign
      </button>
    </div>
  </div>
</div>